import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import newGuide from "./components/addNewGuide";
import { getNewGuideList, deteltNewGuideList, returntNewGuideList } from "@/api/dataAll/newGuide";
export default {
  name: "newGuideSign",
  components: {
    newGuide: newGuide
  },
  mixins: [tabulation],
  data: function data() {
    return {
      pay_types: [],
      num: "1",
      obj: {},
      gameId: "",
      value1: "",
      value2: [],
      showing: false,
      searchData: {
        page: 1
      },
      tableData: [],
      total: 0,
      page: 1,
      show: false,
      adPlacementSingleChoice: true,
      more: true
    };
  },
  created: function created() {},
  methods: {
    searchClick: function searchClick() {
      var _this = this;

      var searchData = JSON.parse(JSON.stringify(this.searchData));
      searchData.ad_placement = searchData.ad_placement == 'valuets' ? [''] : searchData.ad_placement;
      this.reqLoading = true;
      getNewGuideList(searchData).then(function (res) {
        if (res.status == 200) {
          var list = ['game', 'platform', 'channel', 'pkg', 'ad_channel', 'ad_placement'];
          _this.tableData = res.data.data.length ? _this.$utils.dataConversion(res.data.data, list) : [];
          _this.total = res.data.total / 10;
          _this.show = true;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.searchClick();
    },
    handleSource: function handleSource(row) {
      var _this2 = this;

      var data = {
        game_id: this.rawData.game_id,
        special_product_id: row.product_id,
        id: row.id
      };
      returntNewGuideList(data).then(function (res) {
        if (res.status == 200) {
          _this2.$refs.addCdtconversion.init(_objectSpread(_objectSpread({}, res.data), data));
        }
      });
    },
    handleAdd: function handleAdd() {
      this.showing = true;
      this.num = "1";
    },
    changeShow: function changeShow(val) {
      this.showing = val;

      if (this.showing == false && this.num == "2") {
        this.searchClick();
      }
    },
    changeData: function changeData(val) {
      this.obj = val;
    },
    handleDelete: function handleDelete(row) {
      var _this3 = this;

      this.$confirm(this.$t('confirmDeleteProductConversion'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {
                  special_product_id: row.product_id,
                  id: row.id
                };
                deteltNewGuideList(data).then(function (res) {
                  _this3.searchClick();
                });

                _this3.$message({
                  type: "success",
                  message: _this3.$t('deleteSuccessExclamation')
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};